import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  textClassName?: string;
}

export default function Breadcrumb({ items, className = '', textClassName = '' }: BreadcrumbProps) {
  const textCls = textClassName || 'text-gray-400';
  const sepCls = textClassName || 'text-gray-300';
  return (
    <nav
      aria-label="breadcrumb"
      className={`flex flex-wrap items-center gap-1.5 text-[0.8125rem] ${className}`}
    >
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1.5">
            {isLast ? (
              <span className={`${textCls} font-medium whitespace-nowrap`}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href ?? '/'}
                className={`${textCls} hover:text-[#4CAF50] transition-colors duration-200 whitespace-nowrap`}
              >
                {item.label}
              </Link>
            )}
            {!isLast && (
              <span className={`${sepCls} select-none`}>
                <i className="ri-arrow-right-s-line text-sm" />
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
